import { RelatedVideo } from '@/app_components/Article/embeds/RelatedVideo';
import { insertAtNodeRule } from '@/app_lib/htmlParser/inserter/rules/helpers';
import { EmbedPriority, type ParserRule } from '@/app_lib/htmlParser/inserter/rules/types';
import type { Article } from '@/app_lib/types/Article';

/**
 * A parser rule that inserts a <RelatedVideo /> component after the second paragraph (`<p>`) node
 * in the parsed HTML, if the `relatedVideoType` is `'stn_video_media'`.
 *
 * @param adTags - Advertisement tags to be passed to the RelatedVideo component.
 * @param relatedVideoId - The ID of the related video to embed.
 * @param relatedVideoType - The type of the related video; must be `'stn_video_media'` to match.
 * @returns A ParserRule object specifying the insertion logic and matching criteria.
 */
export const embedRelatedVideoRule = ({
  adTags,
  relatedVideoId,
  relatedVideoType,
}: Pick<Article, 'relatedVideoId' | 'adTags' | 'relatedVideoType'>): ParserRule => ({
  insertComponent: ({ index }) => (
    <RelatedVideo
      adTags={adTags}
      key={`related-video ${index}`}
      relatedVideoId={relatedVideoId}
    />
  ),
  insertPosition: 'after',
  match: ({ node, nodeTracker }) => {
    return (
      relatedVideoType === 'stn_video_media' && insertAtNodeRule({ node, nodeTracker, nodeType: 'p', position: 1 })
    );
  },
  priority: EmbedPriority.High,
});
